import { BaseViewLiteralComponent } from '../components/widgets/ViewLiteral';
/** Провайдер, для получения визуальных компонент, их параметров, 
 * состава элементов визуализации. 
 * Например свойства, которые отображаются,
 * который можно редактирования, переводить и т.п.
 */
export class UIProviderBase {
  constructor(graph = null){
    this._graph = graph;
  }

  /** Возвращает массив предикатов, которые могут содержать наименование.
   * Параметром указывается тип элемента (subject для которого определяется наименование). 
   * Тип элементо определяется у subject по значению object для предиката http://www.w3.org/1999/02/22-rdf-syntax-ns#type.
   * Поумолчанию возвращается http://www.w3.org/2000/01/rdf-schema#label (т.е. rdfs:label)
   */
  getPredicateForName(type=null){ return ["http://www.w3.org/2000/01/rdf-schema#label"]; };


  getUIComponent(predicat, operation="view", type=null) { return BaseViewLiteralComponent };
}